import classNames from 'classnames';
import React, { FC } from 'react';

import { Icon } from './Icon';

export interface RecordingButtonProps {
  disabled?: boolean;
  size?: 'md' | 'sm';
  onClick: () => void;
}

const RecordingButton: FC<RecordingButtonProps> = (props) => {
  const onClick = props.disabled ? undefined : props.onClick;

  return (
    <div
      className={classNames(
        'oejr-recording-btn',
        props.disabled && 'oejr-recording-btn-disabled',
        props.size && `oejr-recording-btn-${props.size}`,
      )}
      onClick={onClick}
    >
      <Icon name="users" />
      <div className="play-wrapper">
        <Icon name="circle-play" />
      </div>
    </div>
  );
};

export default RecordingButton;
